import { ofType } from "redux-observable";
import { concat, from } from "rxjs";
import { filter, mapTo, switchMap, take } from "rxjs/operators";
import { IdResource } from "../../../../constants/IdResource";
import { selectInventoryResourceInfo } from "../../../../selectors/selectInventoryInfo";
import { selectRecipeProductionSkipCost } from "../../../../selectors/selectRecipeInfo";
import { actionModalOpen } from "../../../modals/actionModal";
import { IdModal } from "../../../modals/IdModal";
import { TypeActionNotEnoughResource, } from "../../../not-enough-resource/actionNotEnoughResource";
import { IdMissingResourceTypes } from "../../../not-enough-resource/IdMissingResourceTypes";
import { actionOngoingPurchaseStandardSelect } from "../../../ongoing-purchase/actionOngoingPurchase";
import { actionProductionSkip, TypeActionProductionInfo } from "../actionProductionInfo";
export var epicProductionSkipNotEnoughGold = function (action$, state$) {
    return action$.pipe(ofType(TypeActionProductionInfo.SkipNotEnoughResources), switchMap(function (action) {
        var state = state$.value;
        var playerGold = selectInventoryResourceInfo(state, IdResource.Gold);
        var skipCost = selectRecipeProductionSkipCost(state, action.building);
        var missingResources = [
            {
                amount: skipCost.subtract(playerGold.amount),
                typeId: IdResource.Gold,
            },
        ];
        return concat(from([
            actionOngoingPurchaseStandardSelect([
                {
                    missingResources: missingResources,
                    missingType: IdMissingResourceTypes.Gold,
                },
            ]),
            actionModalOpen(IdModal.NotEnoughResource),
        ]), action$.pipe(ofType(TypeActionNotEnoughResource.BuyWithGoldComplete), take(1), filter(function (notEnoughResourceAction) {
            return notEnoughResourceAction.isPurchased;
        }), mapTo(actionProductionSkip(action.building))));
    }));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/info/production/epics/epicProductionSkipNotEnoughGold.ts
// module id = 1941
// module chunks = 3